module.exports = __webpack_public_path__ + "img/monitor.e39a1bd9.png";